















































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {getUserCompanyId} from '@/services/api/user';
import {extractDetailsFromBase64} from '@/services/api/image';
import {redirectTime, acceptedImageTypes} from '@/constants/constants';

@Component({
  methods: {
    ...mapActions(['setCurrentTab', 'showSuccessToast', 'showErrorToast']),
  },
})
export default class CreateLogo extends Vue {
  //store variables
  showSuccessToast: any;
  showErrorToast: any;
  setCurrentTab: any;

  //form variables
  imageName: any = null;
  name = '';
  imagebase64URL = '';
  imageValidationMsg: any = null;
  logoStatus = true;
  loadingBtnStatus = false;
  acceptedImageTypes = acceptedImageTypes;

  //image convert into base 64 string and display on screen
  async onFileChange(event: any) {
    const imageData = event.target.files[0];
    this.imageName = imageData.name;

    try {
      let base64url = await Utils.ngxBase64(imageData);
      if (base64url === null) alert('Something went wrong with image');
      else {
        this.imageValidationMsg = null;

        return (this.imagebase64URL = base64url);
      }
    } catch (error) {
      return 'something went wrong';
    }
  }

  validateImage() {
    if (this.imageName === null || this.imagebase64URL === null) {
      this.imageValidationMsg = 'Please choose image first. ';
      return false;
    } else {
      this.imageValidationMsg = null;
      return true;
    }
  }

  //submit button handler
  async _uploadHandler() {
    if (!this.validateImage()) {
      return false;
    }
    try {
      this.loadingBtnStatus = true;
      const companyid = getUserCompanyId();
      const {imageType, url} = extractDetailsFromBase64(this.imagebase64URL);
      const formData = {
        logoisactive: this.logoStatus,
        logoname: this.imageName,
        logocaption: this.name,
        logoimage: url,
        imagetype: imageType,
        companyid,
      };
      let response = await API.createLogo(formData);

      if (response && response.data) {
        let message: string = response.message;
        if (message.includes('created logo')) {
          message = 'Record added successfully';
        }
        this.showSuccessToast({msg: message});

        setTimeout(() => this._clickHandler(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.loadingBtnStatus = false;
    }
  }
  _clickHandler() {
    this.$router.go(-1);
  }
}
